import keyMirror from 'fbjs/lib/keyMirror';

/**
* @namespace Constants
* @desc App constants
*/

const sessionActionTypes = {
  SESSION_LOGIN_REQUEST: undefined,
  SESSION_LOGIN_SUCCESS: undefined,
  SESSION_LOGIN_FAILURE: undefined,

  SESSION_LOGOUT_REQUEST: undefined,
  SESSION_LOGOUT_SUCCESS: undefined,
  SESSION_LOGOUT_FAILURE: undefined,

  SESSION_SIGNUP_REQUEST: undefined,
  SESSION_SIGNUP_SUCCESS: undefined,
  SESSION_SIGNUP_FAILURE: undefined,

  SESSION_FORGOT_REQUEST: undefined,
  SESSION_FORGOT_SUCCESS: undefined,
  SESSION_FORGOT_FAILURE: undefined,

  SESSION_RESET_REQUEST: undefined,
  SESSION_RESET_SUCCESS: undefined,
  SESSION_RESET_FAILURE: undefined,

  SESSION_LOGIN_AUTH_CODE_REQUEST: undefined,
  SESSION_LOGIN_AUTH_CODE_SUCCESS: undefined,
  SESSION_LOGIN_AUTH_CODE_FAILURE: undefined,

  SESSION_SIGNUP_AUTH_CODE_REQUEST: undefined,
  SESSION_SIGNUP_AUTH_CODE_SUCCESS: undefined,
  SESSION_SIGNUP_AUTH_CODE_FAILURE: undefined,

  SESSION_REGISTERFCM_REQUEST: undefined,
  SESSION_REGISTERFCM_SUCCESS: undefined,
  SESSION_REGISTERFCM_FAILURE: undefined,

  CLIENT_APP_UPDATE_REQUEST: undefined,
};

const pageActionTypes = {
  PAGE_GET_REQUEST: undefined,
  PAGE_GET_SUCCESS: undefined,
  PAGE_GET_FAILURE: undefined,

  PAGE_REFRESH_REQUEST: undefined,
  PAGE_REFRESH_SUCCESS: undefined,
  PAGE_REFRESH_FAILURE: undefined,

  PAGE_ADD_REQUEST: undefined,
  PAGE_ADD_SUCCESS: undefined,
  PAGE_ADD_FAILURE: undefined,

  PAGE_TUTORIAL_ADD_REQUEST: undefined,
  PAGE_TUTORIAL_ADD_SUCCESS: undefined,
  PAGE_TUTORIAL_ADD_FAILURE: undefined,

  PAGE_DELETE_REQUEST: undefined,
  PAGE_DELETE_SUCCESS: undefined,
  PAGE_DELETE_FAILURE: undefined,

  PAGE_UPDATE_REQUEST: undefined,
  PAGE_UPDATE_SUCCESS: undefined,
  PAGE_UPDATE_FAILURE: undefined,

  PAGE_CHECK_SUBDOMAIN_REQUEST: undefined,
  PAGE_CHECK_SUBDOMAIN_SUCCESS: undefined,
  PAGE_CHECK_SUBDOMAIN_FAILURE: undefined,

  PAGE_ENABLE_REQUEST: undefined,
  PAGE_ENABLE_SUCCESS: undefined,
  PAGE_ENABLE_FAILURE: undefined,

  PAGE_VARIANT_ADD_REQUEST: undefined,
  PAGE_VARIANT_ADD_SUCCESS: undefined,
  PAGE_VARIANT_ADD_FAILURE: undefined,

  PAGE_VARIANT_DELETE_REQUEST: undefined,
  PAGE_VARIANT_DELETE_SUCCESS: undefined,
  PAGE_VARIANT_DELETE_FAILURE: undefined,

  PAGE_VARIANT_UPDATE_REQUEST: undefined,
  PAGE_VARIANT_UPDATE_SUCCESS: undefined,
  PAGE_VARIANT_UPDATE_FAILURE: undefined,

  PAGE_VARIANT_CLONE_REQUEST: undefined,
  PAGE_VARIANT_CLONE_SUCCESS: undefined,
  PAGE_VARIANT_CLONE_FAILURE: undefined,

  PAGE_UDPATE_DISTRIBUTION_LOCAL: undefined,

  PAGE_VARIANT_TUTORIAL_UPDATE_LOCAL: undefined,
};

const activityActionTypes = {
  ACTIVITY_GET_REQUEST: undefined,
  ACTIVITY_GET_SUCCESS: undefined,
  ACTIVITY_GET_FAILURE: undefined,

  ACTIVITY_MARK_READ_REQUEST: undefined,
  ACTIVITY_MARK_READ_SUCCESS: undefined,
  ACTIVITY_MARK_READ_FAILURE: undefined,
};

const domainActionTypes = {

  DOMAIN_GET_REQUEST: undefined,
  DOMAIN_GET_SUCCESS: undefined,
  DOMAIN_GET_FAILURE: undefined,

  DOMAIN_REFRESH_ALL_REQUEST: undefined,
  DOMAIN_REFRESH_ALL_SUCCESS: undefined,
  DOMAIN_REFRESH_ALL_FAILURE: undefined,

  DOMAIN_ADD_REQUEST: undefined,
  DOMAIN_ADD_SUCCESS: undefined,
  DOMAIN_ADD_FAILURE: undefined,

  DOMAIN_DELETE_REQUEST: undefined,
  DOMAIN_DELETE_SUCCESS: undefined,
  DOMAIN_DELETE_FAILURE: undefined,

  DOMAIN_CHECK_REACHABILITY_REQUEST: undefined,
  DOMAIN_CHECK_REACHABILITY_SUCCESS: undefined,
  DOMAIN_CHECK_REACHABILITY_FAILURE: undefined,

  DOMAIN_REFRESH_REQUEST: undefined,
  DOMAIN_REFRESH_SUCCESS: undefined,
  DOMAIN_REFRESH_FAILURE: undefined,

  // DOMAIN_SHOW_ADD_FORM: undefined,
  // DOMAIN_HIDE_ADD_FORM: undefined,
  //
};

const galleryActionTypes = {
  GALLERY_GET_REQUEST: undefined,
  GALLERY_GET_SUCCESS: undefined,
  GALLERY_GET_FAILURE: undefined,

  GALLERY_PIXABAY_SEARCH_REQUEST: undefined,
  GALLERY_PIXABAY_SEARCH_SUCCESS: undefined,
  GALLERY_PIXABAY_SEARCH_FAILURE: undefined,

  GALLERY_ADDFROM_PIXABAY_REQUEST: undefined,
  GALLERY_ADDFROM_PIXABAY_SUCCESS: undefined,
  GALLERY_ADDFROM_PIXABAY_FAILURE: undefined,

  GALLERY_USE_PIXABAY_REQUEST: undefined,

  GALLERY_DELETE_REQUEST: undefined,
  GALLERY_DELETE_SUCCESS: undefined,
  GALLERY_DELETE_FAILURE: undefined,

  GALLERY_CLICK_REQUEST: undefined,
  GALLERY_EXIT_SELECT_MODE: undefined,
  GALLERY_UPLOAD_STATUS_CHANGE: undefined,
};

const profileActionTypes = {
  PROFILE_GET_REQUEST: undefined,
  PROFILE_GET_SUCCESS: undefined,
  PROFILE_GET_FAILURE: undefined,

  PROFILE_UPDATE_REQUEST: undefined,
  PROFILE_UPDATE_SUCCESS: undefined,
  PROFILE_UPDATE_FAILURE: undefined,

  PROFILE_EDIT_MODE: undefined,
  PROFILE_PREVIEW_MODE: undefined,
};

const planActionTypes = {
  PLAN_GET_REQUEST: undefined,
  PLAN_GET_SUCCESS: undefined,
  PLAN_GET_FAILURE: undefined,

  PLAN_SELECT_REQUEST: undefined,
  PLAN_SELECT_SUCCESS: undefined,
  PLAN_SELECT_FAILURE: undefined,
};

const paymentActionTypes = {
  PAYMENT_GET_REQUEST: undefined,
  PAYMENT_GET_SUCCESS: undefined,
  PAYMENT_GET_FAILURE: undefined,

  PAYMENT_ADD_REQUEST: undefined,
  PAYMENT_ADD_SUCCESS: undefined,
  PAYMENT_ADD_FAILURE: undefined,

  PAYMENT_CLEAR_CARD_ERROR: undefined,

  PAYMENT_PRIMARY_REQUEST: undefined,
  PAYMENT_PRIMARY_SUCCESS: undefined,
  PAYMENT_PRIMARY_FAILURE: undefined,

  PAYMENT_DELETE_REQUEST: undefined,
  PAYMENT_DELETE_SUCCESS: undefined,
  PAYMENT_DELETE_FAILURE: undefined,
};

const githubActionTypes = {
  GITHUB_GET_REPOS_REQUEST: undefined,
  GITHUB_GET_REPOS_SUCCESS: undefined,
  GITHUB_GET_REPOS_FAILURE: undefined,
};

const appActionTypes = {
  // SHOW_ALERT: undefined,
  // HIDE_ALERT: undefined,

  APP_UPDATE_AVAILABLE: undefined,

  NETWORK_REQUEST: undefined,
  NETWORK_SUCCESS: undefined,
  NETWORK_ERROR: undefined,

};

const editorActionTypes = {

  EDITOR_GET_REQUEST: undefined, // when the editor loads, this is called to fetch data for variantUrlsafe from backend
  EDITOR_GET_SUCCESS: undefined,
  EDITOR_GET_FAILURE: undefined,

  EDITOR_BLOCK_ADD_REQUEST: undefined, // block info (json), and index to insert
  EDITOR_BLOCK_ADD_SUCCESS: undefined,
  EDITOR_BLOCK_ADD_FAILURE: undefined,

  EDITOR_BLOCKS_ADD_REQUEST: undefined, // block info (json), and index to insert
  EDITOR_BLOCKS_ADD_SUCCESS: undefined,
  EDITOR_BLOCKS_ADD_FAILURE: undefined,

  EDITOR_BLOCK_DELETE_REQUEST: undefined,
  EDITOR_BLOCK_DELETE_SUCCESS: undefined,
  EDITOR_BLOCK_DELETE_FAILURE: undefined,

  EDITOR_BLOCK_REORDER_REQUEST: undefined,
  EDITOR_BLOCK_REORDER_SUCCESS: undefined,
  EDITOR_BLOCK_REORDER_FAILURE: undefined,

  EDITOR_BLOCK_UPDATE_REQUEST: undefined,
  // EDITOR_BLOCK_UPDATE_SUCCESS: undefined,
  // EDITOR_BLOCK_UPDATE_FAILURE: undefined,

  EDITOR_BLOCK_SYNC_REQUEST: undefined,
  EDITOR_BLOCK_SYNC_SUCCESS: undefined,
  EDITOR_BLOCK_SYNC_FAILURE: undefined,

  EDITOR_COLOR_UPDATE_REQUEST: undefined,
  EDITOR_COLOR_UPDATE_SUCCESS: undefined,
  EDITOR_COLOR_UPDATE_FAILURE: undefined,

  EDITOR_FONT_UPDATE_REQUEST: undefined,
  EDITOR_FONT_UPDATE_SUCCESS: undefined,
  EDITOR_FONT_UPDATE_FAILURE: undefined,

  EDITOR_SEO_UPDATE_REQUEST: undefined,
  EDITOR_SEO_UPDATE_SUCCESS: undefined,
  EDITOR_SEO_UPDATE_FAILURE: undefined,

  EDITOR_GID_UPDATE_REQUEST: undefined,
  EDITOR_GID_UPDATE_SUCCESS: undefined,
  EDITOR_GID_UPDATE_FAILURE: undefined,

  EDITOR_BLOCK_RENAME_REQUEST: undefined,
  EDITOR_BLOCK_RENAME_SUCCESS: undefined,
  EDITOR_BLOCK_RENAME_FAILURE: undefined,

  EDITOR_PUBLISH_REQUEST: undefined,
  EDITOR_PUBLISH_SUCCESS: undefined,
  EDITOR_PUBLISH_FAILURE: undefined,

  EDITOR_ELEMENT_DELETE_REQUEST: undefined,
  EDITOR_ELEMENT_DELETE_SUCCESS: undefined,
};

const leadActionTypes = {
  LEAD_GET_REQUEST: undefined,
  LEAD_GET_SUCCESS: undefined,
  LEAD_GET_FAILURE: undefined,

  LEAD_REFRESH_REQUEST: undefined,
  LEAD_REFRESH_SUCCESS: undefined,
  LEAD_REFRESH_FAILURE: undefined,

  LEAD_DELETE_REQUEST: undefined,
  LEAD_DELETE_SUCCESS: undefined,
  LEAD_DELETE_FAILURE: undefined,
};

export const ActionTypes = keyMirror({
  ...appActionTypes,
  ...sessionActionTypes,
  ...pageActionTypes,
  ...activityActionTypes,
  ...domainActionTypes,
  ...profileActionTypes,
  ...planActionTypes,
  ...paymentActionTypes,
  ...galleryActionTypes,
  ...githubActionTypes,
  ...editorActionTypes,
  ...leadActionTypes,
});


/**
 * @constant {Object} XHR
 * @memberof Constants
 */
export const XHR = keyMirror({
  SUCCESS: undefined,
  FAIL: undefined,
});



// WEBPACK FOOTER //
// ./scripts/constants/index.js